import type { TextElement } from '@/components/canvas/document/publicTypes';
import { textDocumentToLayoutPlainText } from '../model/textPlain';
import type { TextBlockType, TextDocument } from '../model/textDocument';

export type TextBlockKind = TextBlockType;

export const TEXT_BLOCK_KINDS: TextBlockKind[] = [
  'h1',
  'h2',
  'h3',
  'paragraph',
  'ordered-list-item',
  'unordered-list-item',
];

export function getPlainTextForLayout(
  el: TextElement,
  options: { preserveTrailingEmptyBlocks?: boolean } = {},
): string {
  const text = textDocumentToLayoutPlainText(el.data.document, options);
  return options.preserveTrailingEmptyBlocks
    ? text
    : text.trim() || (el.data.content ?? '').trim();
}

export function detectBlockKind(document: TextDocument | undefined): TextBlockKind {
  return document?.blocks?.[0]?.type ?? 'paragraph';
}

export function headingTagFromKind(kind: TextBlockKind): 'h1' | 'h2' | 'h3' {
  return kind === 'h2' || kind === 'h3' ? kind : 'h1';
}

export function isHeadingBlockKind(kind: TextBlockKind): kind is 'h1' | 'h2' | 'h3' {
  return kind === 'h1' || kind === 'h2' || kind === 'h3';
}
